import { IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { NestedPageHeader } from '../../components/header/page.header';
import { UserProfile } from '../../components/user/user-profile';
import { useBeaconRouter } from '../../route/route.hooks';
import { useActiveWorkspace } from '../../store/workspace/workspace.hooks';

interface RouteParams {
  id: string;
}

interface UserPageProps {
  defaultBackRoute?: string;
}

const UserPage = (props: UserPageProps): ReactElement => {
  const { defaultBackRoute } = props;
  const { i18n } = useTranslation();

  const params = useParams<RouteParams>();
  const workspace = useActiveWorkspace();

  const { builder } = useBeaconRouter();

  let id = params.id;
  let isMyProfile = false;
  if ((workspace?.user.id && params.id === 'me') || id === workspace?.user.id) {
    id = workspace?.user.id;
    isMyProfile = true;
  }

  return (
    <IonPage>
      <NestedPageHeader
        title={
          isMyProfile
            ? i18n.t('common:page_my_profile')
            : i18n.t('common:user_profile')
        }
        defaultBackRoute={defaultBackRoute ?? builder.getHomeRoute()}
      />
      <UserProfile id={id} />
    </IonPage>
  );
};

export { UserPage };
